<app-system-page>
  <div class="text-2xl">Du har ikke de nødvendige rettigheder til at tilgå denne side</div>
</app-system-page>
